import React, { useState, useEffect } from "react";
import { UserReportPageStyle } from "./UserReports.styled";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { CardStyle } from "../../styles/CardStyles";
import DatePicker from "react-date-picker";
import { FormButtonStyle } from "../../styles/FormButtonStyle";
import moment from "moment";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import api from "../../api/configAxios";
import Controller from "../../common/controller";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const UserReports = () => {
  const treeDataRed = useSelector((state) => state.treeDataRed);
  const tempData = treeDataRed?.treeData[0]?.children;

  const [users, setUsers] = useState([]);
  const [dateFrom, setDateFrom] = useState(new Date());
  const [dateTo, setDateTo] = useState(new Date());
  const [btnDisable, setBtnDisable] = useState(false);
  const [error, setError] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [searchData, setSearchData] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (treeDataRed?.treeData[0]?.children.length > 0) {
      const temp = [...treeDataRed?.treeData[0]?.children];
      setUsers(() => {
        let arr = [...temp];
        arr = arr.sort((a, b) => {
          const nameA = a.email.toUpperCase();
          const nameB = b.email.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return arr;
      });
    }
  }, [treeDataRed?.treeData[0]?.children]);

  const filterSearch = (val) => {
    setUsers((data) => {
      const arr = tempData.filter((item) => item.email.includes(val));
      return arr;
    });
  };
  const reset = () => {
    setBtnDisable(false);
    setError("");
    setDateFrom(new Date());
    setDateTo(new Date());
    setSelectedUser("");
    setSearchData("");
    setUsers(treeDataRed?.treeData[0]?.children);
  };
  const sendMessage = async () => {
    try {
      setBtnDisable(true);
      let from = moment(dateFrom).format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
      from = from.split("T")[0];
      from = from + "T00:00:00.0000000";
      const formattedStartDate = moment(from).format(
        "YYYY-MM-DDTHH:mm:ss.SSSSSS"
      );
      let to = moment(dateTo).format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
      to = to.split("T")[0];
      to = to + "T23:59:59.0000000";
      const formattedEndDate = moment(to).format("YYYY-MM-DDTHH:mm:ss.SSSSSS");

      if (selectedUser === "") {
        setBtnDisable(false);
        setError("Select User to Proceed.");
        return;
      }
      if (moment(formattedEndDate).isBefore(formattedStartDate)) {
        setError("The 'End Date' cannot be before the 'Start Date'");
      } else {
        var response = await api.post(
          `${Controller.Email}/sendUserActivityReport`,
          {
            toDate: formattedEndDate,
            fromDate: formattedStartDate,
            email: selectedUser,
          }
        );
        if (response.status === 200 || response.status === 204) {
          reset();
          toast("Report Sent Successfully.");
        } else {
          toast.error("Error has Ocurred. Try Again.", {
            bodyClassName: "notification-div-error",
            progressClassName: "progress-bar-error",
          });
        }
      }
      setBtnDisable(false);
    } catch (error) {
      reset();
      toast.error("Error has Ocurred. Try Again.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  return (
    <UserReportPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>User Reports</HeadingStyle>
        <div className="card-div">
          <CardStyle>
            <h2 className="heading">Start Date</h2>
            <DatePicker
              value={dateFrom}
              className={"date-div"}
              onChange={setDateFrom}
              clearIcon={null}
              calendarIcon={() => (
                <i className="bi bi-calendar4-event calender-icon"></i>
              )}
              maxDate={new Date()}
            />
          </CardStyle>
          <CardStyle>
            <h2 className="heading">End Date</h2>
            <DatePicker
              value={dateTo}
              className={"date-div"}
              onChange={setDateTo}
              clearIcon={null}
              calendarIcon={() => (
                <i className="bi bi-calendar4-event calender-icon"></i>
              )}
              maxDate={new Date()}
            />
          </CardStyle>
        </div>

        {
          <div className="someUser-box">
            <div className="search-bar">
              <input
                className="search-input"
                type="text"
                placeholder="Search"
                value={searchData}
                onChange={(e) => {
                  setSearchData(e.target.value);
                  filterSearch(e.target.value);
                }}
              />
              {searchData != "" ? (
                <i
                  className="bi bi-x search-icon"
                  onClick={() => {
                    setSearchData("");
                    setUsers(treeDataRed?.treeData[0]?.children);
                  }}
                />
              ) : (
                <i className="bi bi-search search-icon" />
              )}
            </div>
            {users.map((item, index) => {
              const selected = selectedUser === item.email;
              return (
                <div
                  key={index}
                  className={selected ? "selected-div" : "userCheck"}
                >
                  {item.email}
                  {!selected && (
                    <button
                      className="select-btn"
                      onClick={() => {
                        setSelectedUser(item.email);
                      }}
                    >
                      Select
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        }
        <FormButtonStyle>
          <div className="btn-div">
            <button
              type="submit"
              className={"btn form-button"}
              disabled={btnDisable}
              onClick={sendMessage}
            >
              Proceed
            </button>
          </div>
        </FormButtonStyle>
        {error !== "" && <TextErrorStyle>{error}</TextErrorStyle>}
      </MainBodyStyle>
      <Footer style="footer" />
    </UserReportPageStyle>
  );
};

export default UserReports;
